import type { RootState } from "single-spa/store/types";

import { createStatePropertySelector } from "../helpers";

import type { SalesWorkspaceState } from "./reducer";

/**
 * Helper selector function for SalesWorkspaceState slice
 * @param state - the root redux state object
 */
const selectSalesWorkspaceStateSlice = (state: RootState): SalesWorkspaceState => state.salesWorkspace;

const select = createStatePropertySelector(selectSalesWorkspaceStateSlice);

export const selectSignalsSlice = select("signals");
export const selectOpportunitiesSlice = select("opportunities");
export const selectCommonSlice = select("common");
export const selectIntentManagementSlice = select("intentManagement");
export const selectIntentSlice = select("intent");
